// extracted by mini-css-extract-plugin
export default {"wrapper":"VIhVc","image":"m4a8C","contentWrapper":"gaXOq","content":"_bWhV","title":"qVLFw","description":"eKf38","button":"d3VjE"};